import clsx from "clsx"
import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { SpinnerComponent } from "../../../../lib/spinner"
import { EditIcon } from "../../../../ui/icons/edit"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MadfarmStaticSelect } from "../../../../ui/molecules/select/newSelect/static"
import { PopupForm } from "../../../../ui/organisms/popupForm"
import { formatterDate, statusLiberatoria, yearOptions } from "../../../../utils"
import { EditLiberatoria } from "../edit"
import { GetAllWaiverFromCodex, resetWaiverFromCreateStatus, resetWaiverFromFilters, resetWaiverFromRequest, resetWaiverFromUpdateStatus, setFromAllowedEntryProtocolId, setFromBreakoutDate, setFromCompletePassing, setFromCustomerId, setFromDeniedEntryProtocolId, setFromExpirationDate, setFromFieldsPassing, setFromIdWaiver, setFromNote, setFromNotificationSubmissionProtocolId, setFromOdc, setFromProtocolDate, setFromSenderOrReceiver, setFromSendingDossier, setFromSubmissionNotificationOdcDate, setFromWaiverDepartureProtocol, setStatusFilter, setYearFilter } from "./dataService/slice"

interface LiberatorieFromCodexProps {
    showPopupFromAdd: boolean
    setShowPopupFromAdd: (value: boolean) => void
}

export function LiberatorieFromCodex({ showPopupFromAdd, setShowPopupFromAdd }: LiberatorieFromCodexProps) {
    const dispatch = useAppDispatch()

    const [showPopup, setShowPopup] = useState<boolean>(false);
    const [showSuccess, setShowSuccess] = useState<boolean>(false)
    const waiverFromState = useAppSelector(state => state.waiverFromCodex)

    useEffect(() => {
        const currentYear = new Date().getFullYear().toString()
        dispatch(GetAllWaiverFromCodex({
            page: 0,
            itemsPerPage: 0,
            year: currentYear
        },))
    }, [waiverFromState.getAllWaiverFromFilters])

    useEffect(() => {
        if (waiverFromState.CreateWaiverFromCodexStatus === 'successfully') {
            dispatch(GetAllWaiverFromCodex(waiverFromState.getAllWaiverFromFilters))
            dispatch(resetWaiverFromUpdateStatus())
            if (showPopupFromAdd) {
                setShowPopupFromAdd(false)
            }
            dispatch(resetWaiverFromRequest())
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
        }
    }, [waiverFromState.CreateWaiverFromCodexStatus])

    useEffect(() => {
        if (waiverFromState.UpdateWaiverFromCodexStatus === 'successfully') {
            dispatch(GetAllWaiverFromCodex(waiverFromState.getAllWaiverFromFilters))
            dispatch(resetWaiverFromCreateStatus())
            setShowPopup(false)
            dispatch(resetWaiverFromRequest())
            setShowSuccess(true)
            setTimeout(() => {
                setShowSuccess(false)
            }, 2500);
        }
    }, [waiverFromState.UpdateWaiverFromCodexStatus])

    const handleOnEditFrom = (w: any) => {
        dispatch(setFromCustomerId(w.customerId))
        dispatch(setFromBreakoutDate(w.breakoutDate))
        dispatch(setFromCompletePassing(w.completePassing))
        dispatch(setFromDeniedEntryProtocolId(w.deniedEntryProtocolId))
        dispatch(setFromAllowedEntryProtocolId(w.allowedEntryProtocolId))
        dispatch(setFromSenderOrReceiver(w.waiverInnerInfo.senderOrReceiver))
        dispatch(setFromFieldsPassing(w.fieldsPassing))
        dispatch(setFromNote(w.note))
        dispatch(setFromOdc(w.odcReference))
        dispatch(setFromWaiverDepartureProtocol(w.departureProtocolId))
        dispatch(setFromSendingDossier(w.sendingDossier))
        dispatch(setFromProtocolDate(w.waiverInnerInfo.protocolDate))
        dispatch(setFromExpirationDate(w.expirationDate))
        dispatch(setFromSubmissionNotificationOdcDate(w.submissionNotificationDate))
        dispatch(setFromNotificationSubmissionProtocolId(w.notificationSubmissionProtocolId))
        dispatch(setFromIdWaiver(w.id))
        setShowPopup(true)
    }

    if (waiverFromState.GetAllWaiverFromCodexStatus === 'loading') {
        return (
            <SpinnerComponent size={'large'} />
        )
    }

    if (waiverFromState.downloadExcelStatus === 'loading') {
        return (
            <SpinnerComponent size={'large'} />
        )
    }

    return (
        <div style={{ padding: '24px' }}>
            {
                (showSuccess) &&

                <div className="gap-[8px] text-left bg-green-300" style={{ margin: '18px', borderRadius: '8px' }}>
                    <span className="text-green-700 fieldsetTitle" style={{ padding: '30px 25px', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '700', display: 'block' }}>
                        Dati salvati correttamente.
                    </span>
                </div>
            }
            <div className="flex flex-col gap-4">
                <div className="grid grid-cols-1 xl:grid-cols-[1fr_auto] gap-4 items-end">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        <MadfarmStaticSelect
                            placeholder={'Seleziona Anno'}
                            value={waiverFromState.getAllWaiverFromFilters.year}
                            options={yearOptions}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setYearFilter(newValue))
                            }}
                            noOptionsMessage="Nessun anno disponibile"
                        />
                        <MadfarmStaticSelect
                            placeholder={'Seleziona Stato'}
                            value={waiverFromState.getAllWaiverFromFilters.status}
                            options={statusLiberatoria}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setStatusFilter(newValue))
                            }}
                            noOptionsMessage="Nessuno stato disponibile"
                        />
                    </div>

                    <div className="flex gap-3 justify-end">
                        <ButtonComponent
                            size="lg"
                            iconPosition="off"
                            variant="outline"
                            label="Pulisci"
                            color="gray"
                            onClick={() => dispatch(resetWaiverFromFilters())}
                        />
                        <ButtonComponent
                            size="lg"
                            iconPosition="off"
                            variant="solid"
                            label="Cerca"
                            color="blue"
                            onClick={() => dispatch(GetAllWaiverFromCodex(waiverFromState.getAllWaiverFromFilters))}
                        />
                    </div>
                </div>

                <div className="w-full overflow-x-auto rounded-xl border border-neutral-200 shadow-sm">
                    <table className="w-full border-collapse text-sm">
                        <thead>
                            <tr className="bg-brandPrimary-600 text-white uppercase text-xs tracking-wide h-[52px]">
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap rounded-tl-xl">Sede</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Data Protocollo</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Numero Protocollo</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Destinatario</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Regione</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Provincia</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Cod. Cliente</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Recesso</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Scadenza</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Evaso</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Tipologia Liberatoria</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Protocollo Liberatoria Negata/Concessa</th>
                                <th className="px-3 py-3 text-left font-semibold whitespace-nowrap">Note</th>
                                <th className="px-3 py-3 text-center font-semibold whitespace-nowrap rounded-tr-xl w-[60px]"></th>
                            </tr>
                        </thead>
                        <tbody>
                            {(waiverFromState.getAllWaiverToResponse?.data || []).length === 0 ? (
                                <tr>
                                    <td colSpan={15} className="px-3 py-4 text-center text-neutral-500 bg-white">
                                        Nessuna liberatoria trovata
                                    </td>
                                </tr>
                            ) : (
                                (waiverFromState.getAllWaiverToResponse?.data || []).map((w, index) => (
                                    <tr
                                        key={w.id ?? index}
                                        className={`border-b border-neutral-200 transition-colors duration-150 hover:bg-brandPrimary-50 ${index % 2 === 0 ? 'bg-white' : 'bg-neutral-50'}`}
                                    >
                                        <td className="px-3 py-2 text-blue-800 font-semibold whitespace-nowrap">
                                            {w.waiverInnerInfo.headQuarter}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(w.waiverInnerInfo.protocolDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.protocolNumber}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.senderOrReceiver}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.region}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.province}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.companyName}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.waiverInnerInfo.clientCode}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(w.waiverInnerInfo.endingDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap text-xs">
                                            {formatterDate(w.expirationDate)}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {statusLiberatoria.filter(({ value }) => value === w.breakoutType).map(el => (
                                                <span key={el.value} className={clsx("labelStatus", { "nonEvasa": w.breakoutType === 'NON_EVASA', "evasa": w.breakoutType === 'EVASA' })}> {el.label}</span>
                                            ))}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            Liberatoria per cambio OdC
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.allowedEntryProtocolId && (
                                                <span>{w.allowedEntryProtocolInfo}</span>
                                            )}
                                            {w.deniedEntryProtocolId && (
                                                <span>{w.deniedEntryProtocolInfo}</span>
                                            )}
                                        </td>
                                        <td className="px-3 py-2 text-neutral-700 whitespace-nowrap">
                                            {w.note}
                                        </td>
                                        <td className="px-3 py-2 w-[60px]">
                                            <div className="flex items-center justify-center gap-2">
                                                <button
                                                    className="relative group p-1 rounded hover:bg-neutral-100 transition-colors"
                                                    onClick={() => {
                                                        handleOnEditFrom(w)
                                                    }}
                                                >
                                                    <EditIcon color={"Orange"} size={18} />
                                                    <span className="absolute bottom-full right-0 mb-1 hidden group-hover:block px-2 py-1 text-xs text-white bg-neutral-800 rounded whitespace-nowrap pointer-events-none z-10">
                                                        Modifica Liberatoria
                                                    </span>
                                                </button>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </table>
                </div>
                {
                    showPopup && (
                        <PopupForm title="Modifica Liberatoria" close={() => { setShowPopup(false); dispatch(resetWaiverFromRequest()) }}>
                            <EditLiberatoria close={() => { setShowPopup(false); dispatch(resetWaiverFromRequest()) }} type="from" />
                        </PopupForm>
                    )
                }
            </div>
        </div>
    )
}